import React, {useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {Route, RouteProps} from 'react-router-dom';
import {compose} from 'redux';
import {Store} from '../store';

interface PublicRouteProps extends RouteProps {
  component: any;
  functionality?: any;
  labels: any;
  busFuncMapDefault: any;
  tenant: any;
}

const PublicRoute = (props: PublicRouteProps) => {
  const {
    component: Component,
    functionality,
    busFuncMapDefault,
    tenant,
    ...rest
  } = props;
  const [showRoute, setShowRoute] = useState<boolean>(true);

  const checkFunctionality = () => {
    if (functionality && busFuncMapDefault) {
      const activeFunctionality = busFuncMapDefault?.[functionality];
      setShowRoute(activeFunctionality);
    }
  };

  const checkRedirectToHomepage = () => {
    if (!showRoute) {
      window.location.href = '/';
    }
  };

  useMemo(() => {
    busFuncMapDefault && tenant && checkFunctionality();
  }, [tenant?.alias, busFuncMapDefault]);

  useEffect(() => {
    checkRedirectToHomepage();
  }, [showRoute]);

  const renderFn = (routeProps: any) => <Component {...routeProps} />;

  return (
    <>
      {showRoute || !functionality ? (
        <Route {...rest} render={renderFn} />
      ) : (
        <></>
      )}
    </>
  );
};

const mapStateToProps = ({strings, busFuncMapDefault, tenant}: any) => ({
  labels: strings.value.pt,
  busFuncMapDefault: busFuncMapDefault.value,
  tenant: tenant.value,
});

export default compose(connect(mapStateToProps)(PublicRoute));
